import { LogMessage } from "./log";
import { environment } from "../constants/environment";
import { flowId } from "../constants/flowId";
import { uuid } from "../constants/uuid";

export const format = (message: LogMessage): Record<string, unknown> | undefined => ({
  ...message,
  _time: Date.now(),
  appname: "help-support-av-flow",
  component: "XHS-AV-FLOW",
  env: environment,
  page: flowId,
  uri: window.location.href,
  uuid,
});
